import Card from '@/components/Card';
import ColumnChart from '@/components/Charts/ColumnChart';
import DonutChart from '@/components/Charts/DonutChart';
import { Text } from '@mantine/core';
import { createStatisticsCardStyles } from './StatisticsCardStyle';
import { isDark } from '@/utils/utils';

const StatisticsCard = ({ title, data }) => {
  const { dark } = isDark();
  const { classes } = createStatisticsCardStyles({ dark });

  return data.length < 5 ? (
    <Card noShadow>
      <Text className={classes.title}>{title}</Text>
      <DonutChart
        data={data.map((item) => ({
          name: item.name,
          value: Number(item.count),
        }))}
        angleField={'count'}
        colorField={'name'}
      />
    </Card>
  ) : (
    <Card noShadow style={{ height: '100%' }}>
      <Text className={classes.title}>{title}</Text>
      <ColumnChart
        data={data.map((item) => ({
          name: item.name,
          value: Number(item.count),
        }))}
      />
    </Card>
  );
};

export default StatisticsCard;
